import { coreState } from '../../stores/core.js'

export function getNextStep(user, members = []) {
    // 0. Profile Completeness Check (Qualifications)
    // OAuth provides name/email, but we need Agency/Level (Step 2)
    if (!user.qualifications || user.qualifications.length === 0) {
        // console.log("[Onboarding] Missing qualifications (Step 2 incomplete). Redirecting.");
        return '/onboarding/business-details';
    }

    // 1. Intent Check
    // console.log(`[Onboarding] Checking Step. Intent: ${user?.onboarding_intent}, ProfileID: ${user?.id}`);
    if (!user.onboarding_intent) {
        return '/onboarding/select-type';
    }

    // 2. Merchant Checks
    if (user.onboarding_intent === 'merchant') {
        const hasMembership = members.length > 0;
        if (!hasMembership) {
            return '/onboarding/create-shop';
        }

        const membership = members[0];
        const shop = coreState.shops.get(membership.shopId);

        if (!shop) return '/onboarding/create-shop';

        // Calibration/Completion Check
        if (!user.signupCompleted) {
            // console.log("[Onboarding] Shop exists but signup not marked complete. Redirecting to wizard.");
            return '/onboarding/create-shop';
        }
    }

    // 3. Success
    const primaryShop = members.find(m => m.shopId);
    if (primaryShop) {
        return `/manage/${primaryShop.shopId}`;
    } else {
        return '/map';
    }
}
